import { FC, useEffect, useMemo, useState } from "react";
import { useAppContext } from "../../../../../../context/app.context";
import { BillingsOrderRelatedTaxiDriverData } from "../../../../../../common/services/billings/order/related/taxi-driver/billings-order-related-taxi-driver";
import useAbort from "../../../../../../common/hooks/use-abort";
import billingsTranslationsHelper from "../../../../../../languages/billings-translations.helper";
import CardComponent from "../../../../../../common/components/card/card.component";
import useBillingsOrderRelatedTaxiDriver from "../../../../../../common/services/billings/order/related/taxi-driver/use-billings-order-related-taxi-driver";
import RelatedBillingsTaxiDriverTableRow from "../../../../common/related-billings/taxi-driver/types/related-billings-taxi-driver-table-row";
import RelatedBillingsTaxiDriverTableComponent from "../../../../common/related-billings/taxi-driver/related-billings-taxi-driver-table.component";
import relatedBillingsTaxiDriverFactory from "./related-billings-taxi-driver.factory";

type RelatedBillingsTaxiDriverProps = {
  orderId: string | undefined;
  planEntryId: string | undefined;
};

const RelatedBillingsTaxiDriverComponent: FC<RelatedBillingsTaxiDriverProps> = (
  props,
) => {
  const translations =
    billingsTranslationsHelper.getBillingsTranslations().relatedBillings
      .taxi_driver;

  const [relatedBillingTaxiDriverData, setRelatedBillingsTaxiDriverData] =
    useState<BillingsOrderRelatedTaxiDriverData[]>([]);

  const { selectedAppLanguage } = useAppContext();
  const taxiDriver = useBillingsOrderRelatedTaxiDriver();
  const taxiDriverAbort = useAbort();

  const taxiDriverData = async () => {
    taxiDriver.load({ orderUuid: props.orderId! }, taxiDriverAbort.signal);
  };

  useEffect(() => {
    if (!props.orderId) return;

    taxiDriverData();
  }, [props.orderId]);

  useEffect(() => {
    if (!taxiDriver.data.data) return;

    setRelatedBillingsTaxiDriverData(taxiDriver.data.data);
  }, [taxiDriver.data.data]);

  const tableRows: RelatedBillingsTaxiDriverTableRow[] = useMemo(() => {
    if (!relatedBillingTaxiDriverData || !props.planEntryId) return [];

    return relatedBillingsTaxiDriverFactory.createTableRows(
      relatedBillingTaxiDriverData,
      props.planEntryId,
    );
  }, [relatedBillingTaxiDriverData, selectedAppLanguage, props.planEntryId]);

  return (
    <CardComponent
      classNames={{ root: "related_billings" }}
      header={{ title: translations.summaryLabel }}
    >
      <RelatedBillingsTaxiDriverTableComponent
        tableRows={tableRows}
        isLoading={taxiDriver.isLoading && !!props.orderId}
      />
    </CardComponent>
  );
};

export default RelatedBillingsTaxiDriverComponent;
